export default __webpack_public_path__ + "static/media/1451.0ee6756f.png";